import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import OnlyServicesSection from "./OnlyServicesSection";
import ServiceAreas from "../AboutUs/ServiceAreas";
import FinalCTA from "../HomePage/FinalCTA";

const FullServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Our Services | Ashlar Building Group</title>
        <meta
          name="description"
          content="Ashlar Building Group offers custom homes, ADUs, full remodels, HOA reconstruction, construction takeovers, and expert witness services across California."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yourdomain.com/services" />
        <meta property="og:title" content="Our Services | Ashlar Building Group" />
        <meta
          property="og:description"
          content="From ground-up custom homes to HOA reconstruction — Ashlar delivers high-value construction projects with integrity, structure, and third-generation craftsmanship."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/services" />
      </Helmet>

      <HeroSection />
      <OnlyServicesSection />
      <ServiceAreas />
      <FinalCTA />
    </>
  );
};

export default FullServicesPage;